var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.84 154.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        fill: #1d1d1b;\n      }\n\n      .cls-6 {\n        font-family: RedHatDisplay-Black, 'Red Hat Display';\n        font-size: 85.16px;\n        font-variation-settings: 'wght' 900;\n        font-weight: 800;\n      }\n\n      .cls-7 {\n        fill: #53b368;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(190.6 105.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 53.57,
    y: 0
  }, "wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 143.92,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 183.35,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 234.7,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 251.3,
    y: 0
  }, "ai")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 154.7,
    height: 154.7,
    rx: 13.59,
    ry: 13.59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.11,109.99c-1.61-1.59-2.13-3.62-.79-5.36,1.24-1.61,3.72-2.03,5.38-.57,2.79,2.45,5.82,4.34,9.29,5.74,17.74,7.17,42.41.64,54.48-14.11,2.64-3.22,4.74-6.84,5.7-10.9,1.06-4.47,5.34-7.34,9.79-6.08,4.28,1.21,6.73,5.8,5.18,10.16-3.69,10.37-11.03,18.6-20.35,24.39-15.21,9.43-35.67,12.6-52.68,6.63-6.06-2.13-11.4-5.37-15.99-9.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.64,66.55c-2.82-.69-7.25.49-9.97,1.35-4.03,1.27-7.84,2.63-11.76,4.2l-11.18,4.47-8.88,3.44c-1.77.69-3.71.36-5.33-.72-1.31-.87-2.34-2.56-2.49-4.42-.31-3.65.99-7.08,3.18-9.98,7.58-10.02,19.55-17.83,30.65-23.49,4.19-2.14,8.37-3.9,12.8-5.48.7-.25,1.53.12,1.81.63s.27,1.49-.27,1.91l-7.42,5.74-14.77,11.87c-3.79,3.05-7.1,6.3-10.52,10.08l7.93-2.36c6.58-1.96,15.47-3.67,22.28-2.94,2.12.23,7.71,1.62,6.54,4.56-.4,1-1.36,1.44-2.59,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3,68.65c.31,6.5-2.27,14.24-7.94,18.03-3.58,2.39-8.07,2.58-11.77.37-2.68-1.6-4.6-3.83-6.02-6.66-3.27-6.54-3.35-14.35-.3-21s9.92-11.14,16.85-7.61c6.1,3.11,8.87,10.32,9.18,16.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8e2a613332b2f5dbd1f1bc9156051080.svg";
export { ForwardRef as ReactComponent };